import type { RootState } from '@app/types'
import { type TypedUseSelectorHook, useSelector } from 'react-redux'

export default useSelector as TypedUseSelectorHook<RootState>
